import React from 'react';
import GeoType from './GeoType';
import PopulationType from './PopulationType';
import CategogyType from './CategoryType';
import GeoNameType from './GeoNameType';
import TableDropdownType from './TableDropdownType';
import { Row, Col } from 'antd';
import branding from '../data/branding';
import Statistic from './Statistic';

const SearchBarContent = () => (

    <div className="searchBar-content">
      <div className="searchBar-what">
      <h3>Topic of Interest</h3>
        <TableDropdownType />
        <div className="searchBar-what__filter">
          
          <CategogyType type="profile"/>
          <PopulationType />
        </div>
      </div>
    
      <div className="searchBar-where">
        <h3>Area of Interest</h3>
        <div className="searchBar-where__dropdown">
          <GeoType />
          <GeoNameType />
        </div>
      </div>
    </div>

);

export default SearchBarContent;



// WEBPACK FOOTER //
// ./src/components/SearchBarContent.js